import { IDeepCopy } from "@common/interfaces/i-deep-copy";

export class ViewStateDelay implements IDeepCopy<ViewStateDelay> {

    public static MinSlideshowDelay: number = 1;
    public static DefaultSlideshowDelay: number = 5;
    public static MaxSlideshowDelay: number = Infinity;

    private prev: number;
    private value: number;
    public get Value() {
        return this.value;
    }
    public set Value(value: number) {
        if (value != this.value) {
            this.prev = this.value;
            this.value = value;
            if (this.OnChange) this.OnChange(this.value, this.prev);
        }
    }

    public get Valid(): boolean {
        return this.Value && this.Value >= ViewStateDelay.MinSlideshowDelay && this.Value <= ViewStateDelay.MaxSlideshowDelay;
    }

    public OnChange: (value: any, prev: any) => any;

    public toJSON() {
        return this.Value;
    }

    public deepCopy(): ViewStateDelay {
        let ret = new ViewStateDelay();
        ret.Value = this.Value;
        return ret;
    }
}
